import { State } from './model';
import { CallStatusDefault, Groups, SelectMode } from '../../../models';

export const StateDefault: State = {
  ...CallStatusDefault,
  keys: [],
  groupedBy: Groups.DEVICES,
  mode: SelectMode.All,
};

export default StateDefault;
